import React, { useEffect } from 'react';
import { isEmpty } from 'lodash';
import { setSlice, enableTableCompare } from '@store/trends/birdChart/actions';
import { useDispatch, useSelector } from 'react-redux';
import { intervalSelector } from '@store/common/selectors';
import { sliceAreaAtom, zoomAreaAtom } from '../atoms';
import { useAtom } from 'jotai';
import { brushSelector } from '@store/trends/birdChart/selectors';
import useFirstRender from '@src/hooks/utils/useFirstRender';
import { Button, Space } from 'antd';

const isZoomed = (zoomArea) => {
  return !isEmpty(zoomArea) && 'startValue' in zoomArea && 'endValue' in zoomArea;
};

function StateTags() {
  const [sliceArea, setSliceArea] = useAtom(sliceAreaAtom);
  const [zoomArea, setZoomArea] = useAtom(zoomAreaAtom);

  const dispatch = useDispatch();
  const interval = useSelector(intervalSelector);
  const brush = useSelector(brushSelector);

  const first = useFirstRender();

  const clearSlice = () => {
    setSliceArea([]);
    dispatch(setSlice([0, 100], [0, 0]));
    dispatch(enableTableCompare(false));
  };

  const clearZoom = () => {
    setZoomArea({ start: 0, end: 100 });
  };

  useEffect(() => {
    if (!first) {
      clearSlice();
      clearZoom();
    }
  }, [interval]);

  // workaround for restore trends workflow until diag section is cleaned up
  useEffect(() => {
    if (brush && (brush[0] || brush[1])) {
      setSliceArea(brush);
    }
  }, [brush]);

  return (
    <Space>
      {!isEmpty(sliceArea) && (
        <Button key="slice" onClick={clearSlice}>
          Clear Slice
        </Button>
      )}
      {isZoomed(zoomArea) && (
        <Button key="zoom" onClick={clearZoom}>
          Clear Zoom
        </Button>
      )}
    </Space>
  );
}

export default StateTags;
